import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useState,
} from "react";
import {
  IInfoDrawerValues,
  INFO_DRAWER_VALUES,
} from "../constants/infoDrawerValues";
import {
  IPageGuideKey,
  PAGE_GUIDES,
  buildPageGuide,
  isPageGuideKey,
} from "../constants/pageGuides";

export type InfoDrawerValue = {
  description: string | ReactNode;
  placement?: "bottom" | "top" | "end" | "start";
  title: string;
  size?: "sm" | "md" | "lg" | "xl" | "xs" | "full";
};
export type IInfoDrawer = {
  value?: InfoDrawerValue;
};

/** Chiavi apribili nel drawer: una metrica singola o una guida di pagina. */
export type InfoDrawerKey = keyof IInfoDrawerValues | IPageGuideKey;

export const InfoDrawerContext = createContext<{
  state?: IInfoDrawer;
  setState: (value?: InfoDrawerKey) => void;
}>({
  state: undefined,
  setState: undefined as any as (value?: InfoDrawerKey) => void,
});

export const InfoDrawerProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<IInfoDrawer>();
  const setValue = (value?: InfoDrawerKey) => {
    if (!value) {
      setState({ value: undefined });
      return;
    }
    // Guida di pagina → composta al volo dalle metriche; metrica → dal registro.
    const drawerValue = isPageGuideKey(value)
      ? buildPageGuide(PAGE_GUIDES[value], INFO_DRAWER_VALUES)
      : INFO_DRAWER_VALUES[value];
    setState({ value: drawerValue });
  };

  return (
    <InfoDrawerContext.Provider value={{ state, setState: setValue }}>
      {children}
    </InfoDrawerContext.Provider>
  );
};
